// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCpz8X_ToIUP1tObcpVFnBsX9U8jgrrb3k",
  authDomain: "shorehamexamination.firebaseapp.com",
  projectId: "shorehamexamination",
  storageBucket: "shorehamexamination.appspot.com",
  messagingSenderId: "953797391275",
  appId: "1:953797391275:web:8fb7257f5fd45b56ac58ee",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
